import { render, staticRenderFns } from "./wdqcqycyc.vue?vue&type=template&id=5dd877ca&scoped=true&"
import script from "./wdqcqycyc.vue?vue&type=script&lang=js&"
export * from "./wdqcqycyc.vue?vue&type=script&lang=js&"
import style0 from "./wdqcqycyc.vue?vue&type=style&index=0&id=5dd877ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd877ca",
  null
  
)

export default component.exports